import React, { Fragment, ReactNode } from 'react';
const TOKEN = /(\*\*[^*]+\*\*|\[[^\]]+\]\([^)]+\))/g;

/**
 * Renders a string with lightweight markup:
 * **bold** and [label](href).
 */
export function renderRich(text: string): ReactNode[] {
  return text.split(TOKEN).filter(Boolean).map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={i} className="font-bold text-fg" data-id="element-185" data-mp="2g0qh013g1wrs">
            {part.slice(2, -2)}
          </strong>;
    }
    const link = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
    if (link) {
      const href = link[2];
      const external = href.startsWith('http');
      return <a key={i} href={href} className="text-accent-soft hover:underline" {...external ? {
        target: '_blank',
        rel: 'noopener noreferrer'
      } : {}} data-id="element-186" data-mp="221gzmy3i4wm8">
            {link[1]}
          </a>;
    }
    return <Fragment key={i} data-id="element-187" data-mp="7rhg96q12jg" data-mpi={i}>{part}</Fragment>;
  });
}